import { languageMap } from ".."
import { bracketIndenting } from "./shared"

languageMap.clojure = bracketIndenting({
	line: ";",
})
